import { Component, ViewChild, TemplateRef, ElementRef, OnInit } from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { AppService } from '../../app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from '../../support/success-snackbar/success-snackbar.component';
import { PaginationService } from '../../PaginationService';
import { messageService } from '../../message.service';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { SessionTimeoutService } from 'src/app/session-timeout-dialog/session-timeout.service';

@Component({
  selector: 'app-investigation-technique-template',
  templateUrl: './investigation-technique-template.component.html',
  styleUrls: ['./investigation-technique-template.component.scss']
})
export class InvestigationTechniqueTemplateComponent implements OnInit {

  isProcessing = true;
  dropDownForInvestigationTechniqueType: any = [];
  _temp: any = {};
  columnLists: any = {};
  documentTemplateDataForGrid: any = [];
  documentTemplateDataForGridTemp: any;
  makeStickyColumns: any;
  dataTypeList: any = [];

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  oddInvTechType: any = null;
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef, private readonly sessionTimeoutService: SessionTimeoutService) { }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.documentTemplateDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.documentTemplateDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  setPagedorserch(page: number, targetpage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.documentTemplateDataForGridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.documentTemplateDataForGridTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.documentTemplateDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }
  orgData: any;


  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    const data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        console.log(this.dynamicLabel);
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  ngOnInit() {

    this.appService.getOneQmsOrganization().subscribe((data: any) => {
      this.orgData = data;
    })
    this.appService.getCodeListsByGroup("DV_INVESTIGATION_TECHNIQUE").subscribe((data: any) => {
      this.dropDownForInvestigationTechniqueType = data;
      this.selectBoxeForInvestigationTechniqueType();
      this.isProcessing = false;
    })
    this.getcallMethod();

  }

  getcallMethod() {
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.documentTemplateDataForGrid = [];
    const data = {

      gridName: "INVESTIGATION_TECHNIQUE_TEMPLATE"
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "QMS_INVESTIGATION_TECHNIQUE_TEMPLATE_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist,
          blobColumnlist: response.bloblist
        }
        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.documentTemplateDataForGrid = response1;
            this.visibleAuditTrail = false;
            console.log('Data - ', response1);
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");

            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }

            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }

            const tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const row of this.documentTemplateDataForGrid) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType == 'CHECKBOX') {
                    row[element.columnName] = row[element.columnName] == "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.setPage(1, 0);
              this.pager.totalPages = undefined;
              this.labelcall();
            });
            this.message.gridList = this.documentTemplateDataForGrid;
            this.collectionSize = this.documentTemplateDataForGrid.length;
            this.totalPages = Math.ceil(this.documentTemplateDataForGrid.length / this.itemsPerPage);

          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });

  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.documentTemplateDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.documentTemplateDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  searchValue: any;
  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.documentTemplateDataForGridTemp = this.documentTemplateDataForGrid;
      this.pager = this.paginationService.getPager(this.documentTemplateDataForGridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.documentTemplateDataForGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.documentTemplateDataForGrid == undefined) {
        return this.documentTemplateDataForGrid;
      }
      if (!this.documentTemplateDataForGrid.length) {
        return this.documentTemplateDataForGrid;
      }
      if (filter) {
        this.documentTemplateDataForGridTemp = this.documentTemplateDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });

      } else {
        this.documentTemplateDataForGridTemp = this.documentTemplateDataForGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.documentTemplateDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of this.documentTemplateDataForGrid) {
        element.childCheckBoxs = true;
      }

    } else {
      this.childCheckBoxs = false;
      for (const element of this.documentTemplateDataForGrid) {
        element.childCheckBoxs = false;
      }
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.documentTemplateDataForGrid[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.TEMPLATE_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.priviousSelectedValue = idx;
    this.visibleAuditTrail = this.documentTemplateDataForGrid.some((list: any) => list.childCheckBoxs);
  }

  refreshGridData() {
    this.getcallMethod();
  }

  investigationTechniqueTemplateFieldData: any = {};
  operationFlag: any;
  popupTitle: any;
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('viewPopup', { static: true }) viewPopup: TemplateRef<any>;

  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleViewPopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  viewPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };


  uploadSuccessMsg: any;
  uploadSuccessIcon: any;
  templateToUpload: File | null = null;
  templateExtention: any;
  preTemplateValidation: any;

  uploadDocuments(e: any) {
    this.templateToUpload = e.target.files[0];
    this.templateExtention = (e.target.files[0].name.split('.').pop() ?? '').toLowerCase();

    this.uploadSuccessMsg = document.getElementById('template-success-msg') as HTMLInputElement;
    this.uploadSuccessIcon = document.getElementById('template-success-icon') as HTMLInputElement;
    this.preTemplateValidation = document.getElementById('preTemplate-validation') as HTMLInputElement;

    if (this.templateToUpload) {
      this.uploadSuccessMsg.style.display = 'block';
      this.uploadSuccessIcon.style.display = 'block';
    } else {
      this.uploadSuccessMsg.style.display = 'none';
      this.uploadSuccessIcon.style.display = 'none';
    }

    if (this.preTemplateValidation != undefined) {
      this.preTemplateValidation.style.display = 'none';
    }

    const file: File = e.target.files[0];

    if (file) {
      let name = file.name.substring(0, file.name.lastIndexOf('.'));
      let extension: any = (file.name.split('.').pop() ?? '').toLowerCase();
      const formData = new FormData();
      formData.append('file', file ?? '');
      formData.append("pageName", "ORG_TEMPLATE");
      formData.append("fileName", name);
      formData.append("extension", extension);
      this.isProcessing = true;
      this.appService.fileUploadToServer(formData).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") { /* empty */ } else {
            this.showSnackBar(data.result, data.resultType);
          }
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      })
    }
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  selectedInvestigationTechniqueType: any = null;
  investigationTechniqueTypeListDropdown: any = [];

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }



  selectBoxeForInvestigationTechniqueType() {
    this.investigationTechniqueTypeListDropdown = [];
    this.investigationTechniqueTypeListDropdown = this.dropDownForInvestigationTechniqueType.map((type: any) => ({
      valueExp: type.codelistCode,
      displayExp: type.codelistName
    }))?.sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) ?? []

  }

  inveTechTypeSearchTxt: any;
  onInvestigationTechniqueTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        if (item) {
          if (this.investigationTypeFieldValue != undefined) {
            this.investigationTypeFieldValue.style.color = '';
          }
          this.selectedInvestigationTechniqueType = item.valueExp;
        } else {
          if (this.investigationTypeFieldValue != undefined) {
            this.investigationTypeFieldValue.style.color = 'red';
          }
          this.selectedInvestigationTechniqueType = null;
        }
      } else {
        this.selectedInvestigationTechniqueType = undefined;
      }
    }
  }

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.infoPopupFlag = false;
    this.operationFlag = 'ADD';
    this.popupTitle = "Create Investigation Technique Template";
    this.selectedInvestigationTechniqueType = null;
    this.investigationTechniqueTemplateFieldData.templateName = '';
    this.investigationTechniqueTemplateFieldData.template = '';
    this.templateToUpload = null;
    this.templateExtention = '';
    this.investigationTechniqueTemplateFieldData.isActive = false;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  preTampleName: any;
  preUploadedTemplate: any;
  preTemplateExtention: any;
  clickedRowTemplateId: any;
  infoPopupFlag: boolean;
  openEditPopup(editRowData: any, editFlag: boolean) {
    this.isProcessing = true;

    if (editFlag) {
      this.visibleAddButton = false;
      this.visibleEditButton = true;
      this.infoPopupFlag = false;
      this.operationFlag = 'EDIT';
      this.popupTitle = "Update Investigation Technique Template";

    } else {
      this.visibleAddButton = false;
      this.visibleEditButton = false;
      this.infoPopupFlag = true;
      this.popupTitle = "Info";
    }

    this.preUploadedTemplate = '';
    this.investigationTechniqueTemplateFieldData.updateReason = '';
    this.clickedRowTemplateId = editRowData.TEMPLATE_ID;
    this.appService.getInvestigationTemplateByTemplateId(editRowData.TEMPLATE_ID).subscribe((response: any) => {
      if (response.template != null) {
        this.preTampleName = response.templateName;
        this.preUploadedTemplate = response.template;
        this.preTemplateExtention = response.templateExtn;
        this.templateExtention = response.templateExtn;
      }

      if (response.investigationTechniqueType) {
        const matchingInvestigator = this.dropDownForInvestigationTechniqueType?.find((item: any) => item.codelistCode == response.investigationTechniqueType);
        if (!matchingInvestigator) {
          this.oddInvTechType = response.investigationTechniqueType;
          this.investigationTechniqueTypeListDropdown.push({
            valueExp: response.investigationTechniqueType,
            displayExp: response.investigationTechniqueType
          })
        }
        this.selectedInvestigationTechniqueType = response.investigationTechniqueType;
      }
      this.investigationTechniqueTemplateFieldData.templateName = response.templateName;
      this.investigationTechniqueTemplateFieldData.isActive = response.isActive == "Y";
      this.isProcessing = false;
    })
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  investigationTypeFieldValue: any;
  templateNameFieldValue: any;
  updateReasonFieldValue: any;
  fieldValidation() {
    this.investigationTypeFieldValue = document.getElementById('investigationType-validation') as HTMLInputElement;
    this.templateNameFieldValue = document.getElementById('templateName-validation') as HTMLInputElement;
    this.updateReasonFieldValue = document.getElementById('updateReason-validation') as HTMLInputElement;

    if (this.selectedInvestigationTechniqueType) {
      this.investigationTypeFieldValue.style.color = '';
    } else {
      this.investigationTypeFieldValue.style.color = 'red';
    }

    if (this.investigationTechniqueTemplateFieldData.templateName == undefined || this.investigationTechniqueTemplateFieldData.templateName == "") {
      this.templateNameFieldValue.style.color = 'red';
    } else {
      this.templateNameFieldValue.style.color = '';
    }

    if (this.visibleEditButton) {
      if (this.investigationTechniqueTemplateFieldData.updateReason == undefined || this.investigationTechniqueTemplateFieldData.updateReason == "") {
        this.updateReasonFieldValue.style.color = 'red';
      } else {
        this.updateReasonFieldValue.style.color = '';
      }
    }

  }

  onFieldFocusout() {
    this.templateNameFieldValue = document.getElementById('templateName-validation') as HTMLInputElement;
    this.updateReasonFieldValue = document.getElementById('updateReason-validation') as HTMLInputElement;
    this.deleteReasonFieldValue = document.getElementById('deleteReason-validation') as HTMLInputElement;

    if (this.templateNameFieldValue != undefined) {
      if (this.investigationTechniqueTemplateFieldData.templateName == "" || this.investigationTechniqueTemplateFieldData.templateName == undefined) {
        this.templateNameFieldValue.style.color = 'red';
      } else {
        this.templateNameFieldValue.style.color = '';
      }
    }

    if (this.updateReasonFieldValue != undefined) {
      if (this.investigationTechniqueTemplateFieldData.updateReason == "" || this.investigationTechniqueTemplateFieldData.updateReason == undefined) {
        this.updateReasonFieldValue.style.color = 'red';
      } else {
        this.updateReasonFieldValue.style.color = '';
      }
    }

    if (this.deleteReasonFieldValue != undefined) {
      if (this.investigationTechniqueTemplateFieldData.deleteReason == "" || this.investigationTechniqueTemplateFieldData.deleteReason == undefined) {
        this.deleteReasonFieldValue.style.color = 'red';
      } else {
        this.deleteReasonFieldValue.style.color = '';
      }
    }
  }

  dataValues: any = {};
  templateByteValue: any;
  addAndEditFunction(investigationTechniqueTemplateFieldData: any) {
    let list = [];
    if (this.orgData.allowedFileExtns) {
      list = this.orgData.allowedFileExtns.split(",");
    };
    if (!list.includes(this.templateExtention.toUpperCase()) && (this.templateToUpload != null || this.templateToUpload != '')) {
      this.templateToUpload = null;
      this.showSnackBar("Please choose the template", "E");
      this.isProcessing = false;
    }
    else
      if (!this.selectedInvestigationTechniqueType || !investigationTechniqueTemplateFieldData.templateName || !this.investigationTechniqueTemplateFieldData.updateReason) {
        this.fieldValidation();
        this.showSnackBar('Please enter the all mandatory fields...', 'E');
        this.isProcessing = false;
      } else if (this.operationFlag == 'ADD') {

        if (this.selectedInvestigationTechniqueType == null) {
          this.investigationTechniqueTemplateFieldData.investigationTechniqueType = null;
        } else {
          this.investigationTechniqueTemplateFieldData.investigationTechniqueType = this.selectedInvestigationTechniqueType;
        }

        this.dataValues = {
          operation: 'I',
          investigationTechniqueType: this.investigationTechniqueTemplateFieldData.investigationTechniqueType,
          templateName: this.investigationTechniqueTemplateFieldData.templateName,
          templateExtn: this.templateExtention,
          isActive: this.investigationTechniqueTemplateFieldData.isActive ? "Y" : "N",
          updateReason: this.investigationTechniqueTemplateFieldData.updateReason
        };

        const qmsInvestigationTechniqueTemplateData = new FormData();
        qmsInvestigationTechniqueTemplateData.append('file', this.templateToUpload ?? '');
        const json = JSON.stringify(this.dataValues);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        qmsInvestigationTechniqueTemplateData.append('qmsInvestigationTechniqueTemplateVwDto', blob);
        this.appService.createQmsInvestigationTechniqueTemplate(qmsInvestigationTechniqueTemplateData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == 'S') {
              this.visibleAddAndEditPopup.close();
              this.getcallMethod();
              this.isProcessing = false;
            }
            this.showSnackBar(Response.result, Response.resultType);
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        delete investigationTechniqueTemplateFieldData.createdOn;
        delete investigationTechniqueTemplateFieldData.updatedOn;

        if (this.selectedInvestigationTechniqueType) {
          this.investigationTechniqueTemplateFieldData.investigationTechniqueType = this.selectedInvestigationTechniqueType;
        } else {
          this.investigationTechniqueTemplateFieldData.investigationTechniqueType = null;
        }

        if (this.templateToUpload == null) {
          this.templateByteValue = this.preUploadedTemplate;
        } else {
          this.templateByteValue = null;
        }

        this.dataValues = {
          operation: 'U',
          templateId: this.clickedRowTemplateId,
          template: this.templateByteValue,
          investigationTechniqueType: this.investigationTechniqueTemplateFieldData.investigationTechniqueType,
          templateName: this.investigationTechniqueTemplateFieldData.templateName,
          templateExtn: this.templateExtention,
          isActive: this.investigationTechniqueTemplateFieldData.isActive ? "Y" : "N",
          updateReason: this.investigationTechniqueTemplateFieldData.updateReason

        };
        const qmsInvestigationTechniqueTemplateData = new FormData();
        qmsInvestigationTechniqueTemplateData.append('file', this.templateToUpload ?? '');
        const json = JSON.stringify(this.dataValues);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        qmsInvestigationTechniqueTemplateData.append('qmsInvestigationTechniqueTemplateVwDto', blob);
        this.appService.updateQmsInvestigationTechniqueTemplate(qmsInvestigationTechniqueTemplateData).subscribe({
          next: (Response: any) => {
            if (Response.resultType == 'S') {
              this.visibleAddAndEditPopup.close();
              this.getcallMethod();
              this.isProcessing = false;
            }
            this.showSnackBar(Response.result, Response.resultType);
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  deleteInvestigationTemplate: any;
  openDeletePopup(deleteRowData: any) {
    console.log(deleteRowData);
    this.operationFlag = 'DELETE';
    this.popupTitle = "Delete Investigation Technique Template";
    this.deleteInvestigationTemplate = deleteRowData;
    if (this.investigationTechniqueTemplateFieldData.deleteReason != undefined) {
      this.investigationTechniqueTemplateFieldData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteReasonFieldValue: any;
  deleteValidation() {
    this.deleteReasonFieldValue = document.getElementById('deleteReason-validation') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteReasonFieldValue.style.color = 'red';
    } else {
      this.deleteReasonFieldValue.style.color = '';
    }
  }

  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      alert('Please enter the mandatory fields...');
      this.isProcessing = false;
    } else {
      let data = {
        templateId: this.deleteInvestigationTemplate.TEMPLATE_ID,
        templateName: this.deleteInvestigationTemplate.TEMPLATE_NAME,
        deleteReason: this.investigationTechniqueTemplateFieldData.deleteReason,
      }
      this.appService.deleteQmsInvestigationTechniqueTemplate(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.visibleDeletePopup.close();
            this.getcallMethod();
            this.isProcessing = false;
          }
          this.showSnackBar(Response.result, Response.resultType);
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  viewerData: any = {};
  downloadTemplates(list: any, colunName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.visibleViewPopup = this.dialog.open(this.viewPopup, this.viewPopupConfig);
    this.appService.getDocumentToViewAudit(docObj).subscribe({
      next: (response: any) => {
        const header = response.headers.get('content-type');
        let binaryData = [];
        this.viewerData = {
          body: response.body,
          contentType: header,
          extn: list.TEMPLATE_EXTN
        }
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    })
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, investigation: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : investigation.TEMPLATE_ID;
    this.auditTrail.gridName = 'INVESTIGATION_TECHNIQUE_TEMPLATE';
    this.auditTrail.report_And_Popup_Name = 'Investigation Technique Template Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(investigation);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Investigation Template Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.filter((item: any) => item.fieldColumnarray !== 'Template').map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  cancelViewPopup() {
    this.visibleViewPopup.close();
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };

  onUserActivity(): void {
    this.sessionTimeoutService.notifyActivity();
  }

  public focusEmpty(): void {
    console.log();
  }
}
